import React, { useEffect, useRef, useState } from "react";
import "./ChatPanel.css";

function formatTime(dateValue) {
  if (!dateValue) {
    return "";
  }
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export default function ChatPanel({
  title,
  messages,
  currentUserId,
  onClose,
  onBack,
  onSend,
  onClickUser,
  error,
  connecting,
  canSend = true,
}) {
  const [draft, setDraft] = useState("");
  const listRef = useRef(null);

  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [messages]);

  const handleSend = (event) => {
    event.preventDefault();
    if (!canSend) {
      return;
    }
    const text = draft.trim();
    if (!text) {
      return;
    }
    onSend(text);
    setDraft("");
  };

  return (
    <section className="chat-panel">
      <header className="chat-panel-header">
        {onBack ? (
          <button type="button" className="chat-panel-back" onClick={onBack}>
            ‹
          </button>
        ) : null}
        <span className="chat-panel-title">{title}</span>
        <button type="button" className="chat-panel-close" onClick={onClose}>
          ×
        </button>
      </header>
      <div className="chat-panel-body" ref={listRef}>
        {error ? <div className="chat-error">{error}</div> : null}
        {connecting && !messages.length ? (
          <div className="chat-empty">Connecting…</div>
        ) : null}
        {!connecting && !error && !messages.length ? (
          <div className="chat-empty">No messages yet. Send the first one.</div>
        ) : null}
        {messages.map((message) => {
          const senderId = String(message.user?.id || "");
          const isOwn = senderId && senderId === String(currentUserId);
          const senderName = message.user?.name || message.user?.id || "User";
          return (
            <div
              key={message.id || `${senderId}-${message.created_at}`}
              className={`chat-message ${isOwn ? "own" : ""}`}
            >
              <div>
                {isOwn ? (
                  <span className="chat-message-name">{senderName}</span>
                ) : (
                  <button
                    type="button"
                    className="chat-message-name"
                    onClick={() =>
                      onClickUser && onClickUser(message.user?.id, senderName)
                    }
                    disabled={!onClickUser}
                  >
                    {senderName}
                  </button>
                )}
                <span className="chat-message-time">
                  {formatTime(message.created_at)}
                </span>
              </div>
              <div className="chat-message-text">{message.text}</div>
            </div>
          );
        })}
      </div>
      <form className="chat-panel-composer" onSubmit={handleSend}>
        <input
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          placeholder={canSend ? "Type a message" : "You can view chat only"}
          disabled={!canSend || connecting}
        />
        <button type="submit" disabled={!canSend || !draft.trim() || connecting}>
          Send
        </button>
      </form>
    </section>
  );
}
